
import { useEffect } from 'react';
import { Courier } from '@/services/types/courierTypes';
import { useCollectionForm } from '../context/CollectionFormContext';

export const useCollectionSearch = () => {
  const {
    couriers,
    setFilteredCouriers,
    searchQuery,
    debouncedSearchQuery,
    activeTab,
    setCouriers
  } = useCollectionForm();

  // Применяем фильтр при изменении поискового запроса
  useEffect(() => {
    if (!couriers || couriers.length === 0) return;

    // Получаем список курьеров для активной вкладки
    let sourceList = couriers;
    
    // Если нет поискового запроса, просто применяем фильтр вкладки
    if (!debouncedSearchQuery) {
      setFilteredCouriers(sourceList);
      return;
    }
    
    // Преобразуем запрос для поиска
    const lowerQuery = debouncedSearchQuery.toLowerCase().trim();
    console.log(`Выполняется поиск по запросу: "${lowerQuery}"`);
    
    // Добавляем более подробное логирование перед фильтрацией
    console.log(`Всего курьеров перед фильтрацией: ${sourceList.length}`);
    
    // Фильтруем курьеров по запросу
    const filtered = sourceList.filter(courier => {
      // Проверка имени (case insensitive)
      const fullName = courier.name ? courier.name.toLowerCase() : '';
      const nameMatch = fullName.includes(lowerQuery);
      
      // Проверка телефона (удаляем все нецифровые символы для поиска)
      const phoneClean = courier.phone ? courier.phone.replace(/[^0-9]/g, '') : '';
      const queryClean = lowerQuery.replace(/[^0-9]/g, '');
      
      // Телефонный номер проверяем только если в запросе есть цифры
      const phoneMatch = queryClean.length > 0 && phoneClean ? phoneClean.includes(queryClean) : false;
      
      // Проверка email
      const emailMatch = courier.email ? 
        courier.email.toLowerCase().includes(lowerQuery) : 
        false;
        
      // Проверка по карте
      const cardMatch = courier.card_last4 ? 
        courier.card_last4.includes(lowerQuery) : 
        false;
      
      // Любое совпадение считается успешным поиском,
      // но для телефонного номера мы добавляем дополнительную проверку
      const isMatch = nameMatch || emailMatch || cardMatch || 
        (phoneMatch && queryClean.length > 0); // Телефон только если есть цифры в запросе
      
      // Подробные логи для диагностики
      if (isMatch) {
        console.log(`Найден курьер по запросу "${lowerQuery}": ${courier.name} (id: ${courier.id.substring(0, 8)}) - nameMatch: ${nameMatch}, phoneMatch: ${phoneMatch}, emailMatch: ${emailMatch}, cardMatch: ${cardMatch}`);
      }
        
      return isMatch;
    });
    
    console.log(`Поиск по "${lowerQuery}": найдено ${filtered.length} из ${sourceList.length} курьеров`);
    setFilteredCouriers(filtered);
    
  }, [debouncedSearchQuery, couriers, activeTab, setFilteredCouriers]);

  return {
    loadCouriers: setCouriers
  };
};
